import {
  getPartCategoryGroups,
  getPartsByCategoryId,
} from "@/api/partCategoryGroups.js";

/** API returns en/it/sq; UI also uses de/fr/es where present. */
export function expandTitleLocales(t) {
  if (!t || typeof t !== "object") {
    return { it: "", en: "", sq: "", de: "", fr: "", es: "" };
  }
  const en = t.en ?? "";
  const it = t.it ?? "";
  const sq = t.sq ?? "";
  return {
    en,
    it,
    sq,
    de: t.de ?? en,
    fr: t.fr ?? en,
    es: t.es ?? en,
  };
}

/**
 * @param {Array<{ _id: string, partCode: number, title: object, enabled: boolean }>} parts
 * @returns {Array<{ _id: string, partCode: number, title: object, enabled: boolean }>}
 */
export function normalizeApiPartRows(parts) {
  if (!Array.isArray(parts)) return [];
  return parts.map((p) => ({
    _id: String(p._id),
    partCode: typeof p.partCode === "number" ? p.partCode : Number(p.partCode),
    title: expandTitleLocales(p.title),
    enabled: p.enabled !== false,
  }));
}

/**
 * Category headers only — does not load per-category `/parts`.
 * @returns {Promise<{ categories: object[] }>}
 */
export async function fetchPartCategoryGroupsCategoriesOnly() {
  const list = await getPartCategoryGroups();
  if (!Array.isArray(list) || list.length === 0) {
    throw new Error("part-category-groups: empty categories");
  }

  const categories = list.map((item, index) => ({
    categoryCode: item.id,
    sortOrder: index + 1,
    title: expandTitleLocales(item.category),
  }));

  return { categories };
}

/**
 * Load one category's part lines — call only after user selects/opens that category.
 * @param {string} categoryId
 */
export async function fetchPartsTemplatesForCategory(categoryId) {
  const parts = await getPartsByCategoryId(categoryId).catch(() => []);
  return normalizeApiPartRows(parts);
}
